<template>
  <div class="share_job">
    <span class="share">Share:</span>
    <span><a :href="'https://www.facebook.com/sharer/sharer.php?u=' + url" target="_blank"><i class="fa fa-facebook-f"></i></a></span>
    <span><a :href="'https://twitter.com/home?status=' + url" target="_blank"><i class="fa fa-twitter"></i></a></span>
    <span><a :href="'https://www.linkedin.com/shareArticle?mini=true&url=' + url" target="_blank"><i class="fa fa-linkedin"></i></a></span>
  </div>
</template>

<script>
export default {
  name: "JobSocial",
  props: ["url"]
}
</script>